/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  Button,
  Form,
  type FormInstance,
  Input,
  Select,
  Switch,
  Tabs,
} from "antd";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import {
  createUserAsync,
  selectAvailableRoles,
  selectCurrentUser,
  selectManageZones,
  updateUserAsync,
} from "../../redux/slices/manageUsers/manageUsersSlice";
import { type UserType } from "../../redux/slices/manageUsers/manageUsersTypes";
import { ZoneTable } from "./ZoneTable/ZoneTable";

const { Option } = Select;

interface GeneralInfoFormProps {
  form: FormInstance;
}

const GeneralInfoForm: React.FC<GeneralInfoFormProps> = ({
  form,
}: GeneralInfoFormProps) => {
  const zones = useAppSelector(selectManageZones);
  const currentManagedUser = useAppSelector(selectCurrentUser);
  const availableRoles = useAppSelector(selectAvailableRoles);
  const dispatch = useAppDispatch();
  const [passwordChange, setPasswordChange] = useState(false);

  useEffect(() => {
    if (currentManagedUser != null) {
      form.setFieldsValue(currentManagedUser);
    } else {
      form.resetFields();
    }
  }, [currentManagedUser]);

  const onFinish = (values: any): void => {
    console.log("Received values of form: ", values);
    console.log("zones of form: ", zones);

    const newUser: UserType = {
      ...values,
      zones,
    };
    if (currentManagedUser != null) newUser.id = currentManagedUser.id;
    console.log("new user", newUser);
    if (currentManagedUser?.id != null) {
      dispatch(updateUserAsync(newUser));
    } else {
      dispatch(createUserAsync(newUser));
    }
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 17 },
    },
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 5,
      },
    },
  };

  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select style={{ width: 70 }}>
        <Option value="+7">+7</Option>
      </Select>
    </Form.Item>
  );

  const getPassField = (): JSX.Element => {
    const passField = (
      <Form.Item
        name="password"
        label="Password"
        rules={[
          {
            required: true,
            message: "Please input your password!",
          },
        ]}
      >
        <Input.Password />
      </Form.Item>
    );
    if (currentManagedUser == null) {
      return <>{passField}</>;
    } else {
      if (!passwordChange) {
        return (
          <>
            <Form.Item {...tailFormItemLayout}>
              <Button
                type="link"
                onClick={() => {
                  setPasswordChange(true);
                }}
              >
                Изменить пароль
              </Button>
            </Form.Item>
          </>
        );
      } else {
        return (
          <>
            {passField}
            <Form.Item {...tailFormItemLayout}>
              <Button
                type="link"
                onClick={() => {
                  setPasswordChange(false);
                }}
              >
                Не изменять пароль
              </Button>
            </Form.Item>
          </>
        );
      }
    }
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="register"
      // defaultValue={}
      onFinish={onFinish}
      initialValues={{
        prefix: "+7",
      }}
      scrollToFirstError
    >
      <Form.Item
        name="login"
        label="Логин"
        rules={[{ required: true, message: "Введите логин", whitespace: true }]}
      >
        <Input disabled={currentManagedUser?.id != null} />
      </Form.Item>
      <Form.Item
        name="name"
        label="Имя"
        rules={[{ required: true, message: "Введите имя", whitespace: true }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="phone"
        label="Номер"
        rules={[{ required: true, message: "Введите номер" }]}
      >
        <Input addonBefore={prefixSelector} style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item
        name="email"
        label="E-mail"
        rules={[
          {
            type: "email",
            message: "The input is not valid E-mail!",
          },
          {
            required: true,
            message: "Please input your E-mail!",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="role"
        label="Роль"
        rules={[{ required: true, message: "Выберите роль" }]}
      >
        <Select>
          {availableRoles.map((role) => (
            <Option key={role} value={role}>
              {role}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="isActive"
        label="Статус"
        valuePropName="checked"
        initialValue={false}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Switch checked={true} />
      </Form.Item>

      {getPassField()}

      {/* <Form.Item
        name="website"
        label="Website"
        rules={[{ required: true, message: 'Please input website!' }]}
      >
        <AutoComplete options={websiteOptions} onChange={onWebsiteChange} placeholder="website">
          <Input />
        </AutoComplete>
      </Form.Item>

      <Form.Item
        name="intro"
        label="Intro"
        rules={[{ required: true, message: 'Please input Intro' }]}
      >
        <Input.TextArea showCount maxLength={100} />
      </Form.Item>



      <Form.Item label="Captcha" extra="We must make sure that your are a human.">
        <Row gutter={8}>
          <Col span={12}>
            <Form.Item
              name="captcha"
              noStyle
              rules={[{ required: true, message: 'Please input the captcha you got!' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Button>Get captcha</Button>
          </Col>
        </Row>
      </Form.Item>

      <Form.Item
        name="agreement"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject(new Error('Should accept agreement')),
          },
        ]}
        {...tailFormItemLayout}
      >
        <Checkbox>
          I have read the <a href="">agreement</a>
        </Checkbox>
      </Form.Item>
      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit">
          Register
        </Button>
      </Form.Item> */}
    </Form>
  );
};

interface AddUserFormProps {
  form: FormInstance<any>;
}

const AddUserForm: React.FC<AddUserFormProps> = ({
  form,
}: AddUserFormProps) => {
  return (
    <Tabs
      defaultActiveKey="1"
      items={[
        {
          label: `Общая информация`,
          key: "info",
          children: <GeneralInfoForm form={form} />,
        },
        {
          label: `Зоны видимости`,
          key: "zones",
          children: <ZoneTable form={form} />,
        },
      ]}
    />
  );
};

export default AddUserForm;
